// extracted by mini-css-extract-plugin
export default {"container":"space_container__YlaMi","changes":"space_changes__8ExuT"};